<template>
	<!-- <div>
	
	</div>-->
	<div class="main">
		<!-- <div
			style="position: relative;height:100%;width:100%"
			v-if="conversationData.length<1 && waitingData.length<1 "
		>
			<div id="noMessage">
				<div style="font-size: 82px;">
					<i class="el-icon-chat-dot-square"></i>
				</div>当前没有接入用户
			</div>
		</div>-->
		<!-- v-show="conversationData.length>0 || waitingData.length>0" -->
		<div class="main1">
			<div class="aside">
				<div class="points">
					当前排队人数：{{ waitingData.length }}
					<a class="connect" @click="manualAccessShows()">手动接入</a>
				</div>
				<div class="asideList">
					<list
						title="会话中"
						ref="NextConversation"
						assemblyType="1"
						@cusultInfo="cusultInfo($event)"
						:menus="conversationData"
					></list>
					<list
						title="等待中"
						assemblyType="2"
						:menus="waitingData"
						@cusultInfo="cusultInfo($event)"
						@manualAccess="tranOnAccess"
					></list>
					<list
						title="离线"
						assemblyType="3"
						:menus="offlineList"
						@cusultInfo="cusultInfo($event)"
					></list>
				</div>
			</div>
			<div :class="answer">
				<chatBox
					ref="chatBox"
					@Message="sendMessage($event)"
					@UploadFile="uploadFile($event)"
					@chatBoxTransfer="chatBoxTransfers($event)"
					@closingSession="closingSession"
					@GetChatRecord="getChatRecord"
					@openMiniDialog="miniMessageShow"
					@quickReplyShow="quickReply"
					@SearchChatBox="searchChatBox"
					@saveAddressMonitorting="saveAddressMonitorting"
					@ckResendMsg="clickResendMessage"
					:Pagination="chatBoxPageination"
					:ConsultId="currentObj.consultId"
					:UserConversationId="currentObj.userConversationId"
					:ConversationLogId="currentObj.conversationLogId"
					:Dialogues="currentObj.dialogues"
					:entryTimeMillisecond="currentObj.entryTimeMillisecond"
					:QuickQuery="quickQuery"
					:cousultNickName="currentObj.cousultNickName"
					:assemblyType="currentObj.assemblyType"
					:create_time="currentObj.entryTime"
					:TransferRemarks="currentObj.transferRemarks"
					:accessType="currentObj.accessType"
					:kfDefaultHeadimg="kfDefaultHeadimg"
					:consultDefaultHeadimg="consultDefaultHeadimg"
					:consultNickName="consultNickName"
					:kfNickName="kfNickName"
					:errSendMsgMessage="errSendMsgMessage"
					@selectedReply="operationSelectedReply"
				></chatBox>
			</div>
			<quickReply
				@openQuickList="openQuickList"
				:quickList="quickList"
				:quickQuery="quickQuery"
				@close="close"
				@TagType="quickTagType"
				:isShow="reply"
			></quickReply>
			<manualAccess
				:dialogTableVisible="manualAccessShow"
				:data="manualAccessData"
				@tranHandleClose="tranHandleClose($event)"
				@onAccess="tranOnAccess"
			></manualAccess>
			<transitionModelBox
				:transferUsers="transferUsers"
				:visible="transferVisible"
				@onClose="transferVisible = false"
				@confirmTransferOrder="confirmTransferOrder"
			></transitionModelBox>
			<searchSession
				:dialogSearch="dialogSearchs"
				:searchDialogues="searchDialogues"
				:searchKeyWord="searchKeyWord"
				:currentObj="currentObj"
				:kfDefaultHeadimg="kfDefaultHeadimg"
				:consultDefaultHeadimg="consultDefaultHeadimg"
				:consultNickName="consultNickName"
				@close="searchClose"
				@searchDialogue="searchDialogue"
				@SearchChatBox="searchChatBox"
			></searchSession>
			<miniMessage
				@sendMiniMessage="sendMessage"
				@close="miniMessageClose"
				:dialogVisible="miniMessageVisible"
				:data="miniList"
				:currentObj="currentObj"
			></miniMessage>
			<userinfor
			v-show="userOrQuickList == 0"
				:addressList="addressList"
				:currentUserInfo="currentUserInfo"
				:consultationTypes="consultationTypes"
				:serviceRecord="serviceRecord"
				:channelName="currentObj.channelName"
				:accessChatId="currentObj.accessChatId"
				:openid="currentObj.consultId"
				@saveCustomerCenter="saveCustomerCenter"
				@updUserInfo="updUserInfo"
				ref="userinfor"
			></userinfor>
			<problemList
				v-show="userOrQuickList == 1"
				:quickObject="quickObjects"
				:quickTagTypes="quickTagTypes"
				@sendQuick="sendQuick"
				@openUserInfo="userOrQuickList = 0"
				@selectedReply="operationSelectedReply"
			></problemList>
		</div>
	</div>
	<!-- </div> -->
</template>
<script>
import list from '@/components/customer/talks/list'
import chatBox from '@/components/customer/talks/chatBox'
import quickReply from '@/components/customer/talks/quickReply'
import manualAccess from '@/components/customer/talks/manualAccess'
import transitionModelBox from './transitionModeBox'
import searchSession from './searchSession'
import * as Signalr from '@microsoft/signalr'
import {
	getJoinModel,
	getSendMessage,
} from '@/components/customer/talks/ViewModel'
let emojiData = require('@/assets/emoji/emoji.json')
import { getUserConfigs } from '@/utils/GetUserConfig'
import { sortByKey, Sum, GUID } from '@/utils/utils'
import miniMessage from './miniMessage'
import { DateTime } from '@/utils/common'
import userinfor from './userInfo'
import problemList from './problemList'
import { sendMessageState } from '@/enum/SendMessage'
import { ListenerPageVisibility } from '@/utils/ListenerPageVisibility'
import preventReClick from '@/utils/preventReClick'
export default {
	name: 'talk',
	props: [],
	data() {
		return {
			checkBox: false,
			show: false,
			emojiIcon: emojiData.icon,
			eindex: 0,
			answer: 'answer',
			reply: 'reply',
			tabclass1: 'on',
			tabclass2: '',
			conversationData: [], //当前连接人数
			waitingData: [], //当前等待人数
			currentObj: {},
			currentUserInfo: {}, //当前用户信息
			manualAccessShow: false, //手动接入
			manualAccessData: [],
			joInTag: [
				{ key: 1, name: '新接入', class: 'tips green' },
				{ key: 2, name: '转接', class: 'tips red' },
				{ key: 3, name: '手动接入', class: 'tips blue' },
			],
			transferUsers: [],
			transferVisible: false,
			chatBoxPageination: {},
			dialogSearchs: false,
			miniMessageVisible: false,
			miniList: [], //小程序
			quickList: [],
			quickQuery: [],
			addressList: [],
			offlineList: [], //离线列表
			consultationTypes: [], //咨询类型
			serviceRecord: [],
			searchDialogues: {
				list: [],
				pagination: {},
			}, //搜索聊天记录
			searchKeyWord: '',
			kfDefaultHeadimg: '',
			consultDefaultHeadimg: '',
			consultNickName: '',
			kfNickName: '',
			userOrQuickList: 0, //0 用户信息  1 快捷回复列表
			quickObjects: {},
			selectedReply: [],
			quickTagTypes: 1,
			sendMessageBuffer: [], //发送数据缓冲区 如发送成功则删除 没有得到发送成功的消息则重发
			bufferResendSuccess: false,
			sendMessageEnum: {
				2000: '发送失败,请您稍后重试',
				2001: '用户已离开小程序，请稍后在试',
				2002: '对方网络不太好，请稍后重试',
				2003: '用户已回小程序，请您重试',
			},
			errSendMsgMessage: '',
			manualAccessClick: false,
		}
	},
	watch: {},
	mounted: function () {},
	created: function () {
		console.debug('------是新版--------------1.0.1')
		let vm = this
		let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
		this.kfNickName = loginModel.nickName
		this.kfDefaultHeadimg = localStorage.getItem('defaultKfHeadimg')
		this.consultDefaultHeadimg = localStorage.getItem(
			'defaultConsultHeadimg'
		)
		this.init() //建立webstock连接
		this.getExistingLian() //获取连接成功人
		this.getAwait() //获取等待人
		this.getMiniList()
		this.getQuick() //获取快捷回复
		this.getAddress() //获取省市区
		this.getOfflineList() //获取离线列表
		this.getConsultationTypes() //获取咨询类型
		if (this._globle.resend == null || this._globle.resend == undefined) {
			clearInterval(this._globle.resend)
		}
		this._globle.resend = setInterval(function () {
			vm.bufferResend()
		}, 3000)
		var account = this.getAccount()
		if (account == 'Nestle2020001' || account == 'Nestle2020002') {
			var obj = new Object()
			obj.consultId = 'oehM54ydqt0C3mxdqXV_LKW0n79A'
			obj.accessChatId = 12482
			this.cusultInfo(obj)
		}
		//this.getUserInfo('oehM54ydqt0C3mxdqXV_LKW0n79A', 12482)
	},
	beforeRouteLeave(to, form, next) {
		this.asynConversationCount()
		next()
	},
	methods: {
		init() {
			//建立WebStock连接；
			// 调用实例
			let isShow = true
			let navChange = new ListenerPageVisibility()
			navChange.linsternVisibility(
				// 页面是隐藏状态执行方法
				() => {
					// TODO 浏览器标签页处于隐藏状态时,执行的方法
					console.log(navChange)
					console.log('隐藏')
					isShow = false
				},
				// 页面是可见状态执行方法
				() => {
					isShow = true
					document.title = ''
				}
			)
			let $this = this
			this.connection.off('RefreshWorkOrder')
			this.connection.off('ReceiveMessages')
			this.connection.off('MegCall')
			this.connection.off('JoinMsg')
			this.connection.off('JoinAwait')
			this.connection.off('QuitList')
			this.connection.off('ReceiveOfflineList')
			this.connection.off('UpdMiniState')
			this.connection.off('ReconnectionSupplementPush')
			this.connection.on('ReconnectionSupplementPush',(item)=>{
				let model = getJoinModel(item, '', '')
				console.debug(model)
				if(this.conversationData.findIndex(d=>d.cousultId==model.cousultId)==-1) {
					this.conversationData.push(model)
				}			
			})
			/**
			 * 刷新工单
			 */
			this.connection.on('RefreshWorkOrder', (message) => {
				$this.getUserInfo(
					$this.currentObj.consultId,
					$this.currentObj.accessChatId
				)
			})
			/***
			 * 接收新的消息
			 */
			this.connection.on('ReceiveMessages', (message) => {
				debugger
				if (!isShow) {
					document.title = '通知：您有一条新的消息~~~'
				}
				//接收消息
				let obj = $this.conversationData.find(
					(d) => d.conversationLogId == message.conversationLogId
				)
				// navChange.hiddenRemind('通知：您有一条新的消息~~~')
				if (obj == undefined) {
					console.debug('错误Id:' + message.conversationLogId)
					return
				}
				if (
					obj.dialogues.findIndex(
						(d) => d.groupMessageId == message.groupMessageId
					) < 0 //已存在不加入
				) {
					obj.dialogues.push(message)
					obj.recentNewsTime = message.sendTime
					obj.recentNewsTimeHM = message.sendTimeHM
					if (!obj.isCheck) {
						obj.unreadCount = obj.unreadCount + 1
					}
					if (obj.dialogues == undefined || obj.dialogues == null) {
						obj.dialogues = []
					}
					$this.conversationData = sortByKey(
						$this.conversationData,
						'unreadCount',
						'desc'
					)
					var route = $this.$route.path
					if (route.indexOf('customs/talks') == -1) {
						$this.$message({
							type: 'success',
							message: '您有新的消息~',
						})
					}
					$this.msgCallBack(
						message.dialogues[0].consultId,
						message.groupMessageId
					) //通知已接收
				} else {
					$this.msgCallBack(
						message.dialogues[0].consultId,
						message.groupMessageId
					) //通知已接收
				}
				console.debug({
					consultId: message.dialogues[0].consultId,
					content: message.dialogues[0].content,
					groupMessageId: message.groupMessageId,
				})
			})
			/***
			 * 消息成功回调
			 */
			this.connection.on('MegCall', (message) => {
				console.debug(message)
				let obj = $this.conversationData.find(
					(d) => d.cousultId == message.sender
				)
				if (obj != null && obj != undefined) {
					let findDia = obj.dialogues.find(
						(d) => d.groupMessageId == message.messageGroupId
					) //发送成功
					if (findDia != undefined) {
						findDia.isSuccess = sendMessageState.Success
					}
					let index = $this.sendMessageBuffer.findIndex(
						(d) => d.groupMessageId == message.messageGroupId
					)
					if (index > -1) {
						$this.sendMessageBuffer.splice(index, 1)
					}
					$this.clareMsgBuffer(message.messageGroupId)
				} else {
					$this.clareMsgBuffer(message.messageGroupId)
				}
			})
			/***
			 * 加入成功通知
			 */
			this.connection.on('JoinMsg', (message) => {
				//新加入人员
				let vm = $this
				let cindex = $this.conversationData.findIndex(
					(d) => d.cousultId == message.joinSuccess.cousultId
				)
				if (cindex > -1) {
					vm.asynJoinTime(
						message.joinSuccess.accessChatId,
						message.joinSuccess.cousultId,
						message.joinSuccess.userConversationId
					)
					return
				}
				var route = $this.$route.path
				if (route.indexOf('customs/talks') == -1) {
					$this.$message({
						type: 'success',
						message: '您有新的用户接入~',
					})
				}
				if (!isShow) {
					document.title = '通知：您有新的用户接入了~~~'
				}
				let joinTags = $this.joInTag.find(
					(d) => d.key === message.joinSuccess.accessType
				)
				 
				let model = getJoinModel(
					message.joinSuccess,
					joinTags.key,
					joinTags.class
				)
				if (
					model.dialogues != undefined &&
					model.dialogues != null &&
					model.dialogues instanceof Array == true
				) {
					if (
						message.dialogues instanceof Array == true &&
						message.dialogues.length > 0
					) {
						model.dialogues.push({
							groupMessageId: '',
							dialogues: message.dialogues,
						})
					}
				} else {
					 model.dialogues=message.dialogues;
					//model.dialogues = []
					// model.dialogues.push({
					// 	groupMessageId: '',
					// 	dialogues: message.dialogues,
					// })
				}
				$this.conversationData.push(model)
				var str = getUserConfigs()
				// console.log(`测试:${JSON.stringify(str)}`)
				if (str == undefined) {
					return
				}
				if (
					str.find((d) => d.id == 1 && d.selected == 1) != undefined
				) {
					//按照时间升序
					vm.conversationData = sortByKey(
						[...vm.conversationData],
						'entryTimeMillisecond',
						'acs'
					)
				} else if (
					str.find((d) => d.id == 2 && d.selected == 1) != undefined
				) {
					vm.conversationData = sortByKey(
						[...vm.conversationData],
						'entryTimeMillisecond',
						'desc'
					)
				} else if (
					str.find((d) => d.id == 3 && d.selected == 1) != undefined
				) {
					//排队等候优先
					vm.conversationData = sortByKey(
						[...vm.conversationData],
						'waitingTime',
						'desc'
					)
				}

				vm.asynConversationCount() //同步会话数量
				vm.asynJoinTime(
					model.accessChatId,
					model.cousultId,
					model.userConversationId
				)
			})
			/***
			 * 加入等待通知
			 */
			this.connection.on('JoinAwait', (message) => {
				//接收等待人员
				let model = getJoinModel(message, '', '')
				$this.waitingData.push(model)
			})
			/***
			 * 退出等待通知
			 */
			this.connection.on('QuitAwait', (quitId) => {
				let index = $this.waitingData.findIndex(
					(d) => d.cousultId == quitId
				)
				if (index > -1) {
					$this.waitingData.splice(index, 1)
				}
			})
			/***
			 * 结束当前会话通知
			 */
			this.connection.on('QuitList', (res) => {
				let vm = $this
				let index = vm.conversationData.findIndex(
					(d) => d.cousultId == res.cousultId
				)
				if (index > -1) {
					let consultNickName =
						vm.conversationData[index].cousultNickName
					vm.conversationData.splice(index, 1)
					if (res.endType == 70002) {
						vm.$message({
							type: 'warning',
							message: `${consultNickName}已主动结束会话`,
						})
					} else if (res.endType == 70003) {
						vm.$message({
							type: 'warning',
							message: `${consultNickName}长时间没有回复，系统自动结束`,
						})
					}
					let isCheck = vm.currentObj.consultId == res.cousultId
					if (isCheck) {
						vm.restoreDefault()
					}
					vm.sendMessageBuffer = vm.sendMessageBuffer.filter(
						(d) => d.Receiver != res.cousultId
					)
				}
				vm.asynConversationCount() //同步会话数量
				vm.clareQuitSession(res.cousultId)
			})
			/***
			 * 离线通知
			 */
			this.connection.on('ReceiveOfflineList', (data) => {
				let vm = this
				if (data != undefined) {
					data.isCheck = false
					vm.offlineList.push(data)
				}
			})
			this.connection.on('UpdMiniState', (data) => {
				let obj = $this.conversationData.find(
					(d) => d.userConversationId == data.conversationId
				)
				if (obj == undefined) {
					console.debug('错误Id:' + data.conversationId)
					return
				}
				obj.miniStateEnum = data.miniState
				if ($this.currentObj.consultId == data.miniOpenId) {
					$this.errSendMsgMessage =
						$this.sendMessageEnum[obj.miniStateEnum]
				}
			})
		},
		/***
		 * 接收到的消息回调
		 */
		msgCallBack(receiver, messageGroupId, isSuccess = true) {
			debugger
			let vm = this
			var obj = new Object()
			obj.Receiver = receiver
			obj.MessageGroupId = messageGroupId
			obj.IsSuccess = isSuccess
			vm.connection.send('MsgCallback', obj) //告诉服务器 已接收
			// vm.clareMsgBuffer(messageGroupId) //清除服务器中的缓冲
			// //消息接收成功的通知
			// vm.axios.post('sendMessage/msgCall', {
			// 	Receiver: receiver,
			// 	MessageGroupId: messageGroupId,
			// 	IsSuccess: isSuccess
			// })
		},
		/**
		 * 清除服务器中的缓存
		 */
		clareMsgBuffer(msgGuid) {
			this.connection.send('clareMsgBuffer', msgGuid)
		},
		/***
		 * 点击重发
		 */
		clickResendMessage(val) {
			let vm = this
			let obj = vm.conversationData.find(
				(d) => d.conversationLogId == val.conversationLogId
			)
			if (obj != undefined) {
				let index = obj.dialogues.findIndex(
					(d) => d.groupMessageId == val.groupMessageId
				)
				if (index > -1) {
					obj.dialogues[index].isSuccess = sendMessageState.Sending
					vm.sendMessageBuffer.push(val)
				}
			}
			vm.bufferSendMessage(val)
		},
		/**
		 * 清除退出的缓存
		 */
		clareQuitSession(Id) {
			this.axios.get('ClareBuffer/ClareQuitSessionBuffer', {
				params: { clareId: Id },
			})
		},
		bufferResend() {
			let date = new DateTime()
			let vm = this
			// if (this.bufferResendSuccess == true) {
			// 	//防止多次进入
			// 	return
			// }
			vm.sendMessageBuffer.forEach((d) => {
				let currentTime = date.Now()
				let currentTimeSpan = date.getTimestamp(currentTime)
				let itemTimeSpan = date.getTimestamp(d.sendTime)
				let diff = currentTimeSpan - itemTimeSpan
				if (
					diff >= 5 &&
					(d.resendCount < 3 || d.resendCount == undefined)
				) {
					//进行重发
					vm.bufferSendMessage({ ...d })
					d.resendCount += 1
				} else if (d.resendCount >= 3) {
					let obj = vm.conversationData.find(
						(f) => f.cousultId == d.Receiver
					)
					if (obj != null && obj != undefined) {
						obj.dialogues.find(
							(c) => c.groupMessageId == d.groupMessageId
						).isSuccess = sendMessageState.Error
					}
					let index = vm.sendMessageBuffer.findIndex(
						(m) => m.groupMessageId == d.groupMessageId
					)
					vm.updSendError(d.groupMessageId)
					vm.errSendMsgMessage = vm.sendMessageEnum[obj.miniStateEnum]
					//更新发送失败原因
					if (index > -1) {
						vm.sendMessageBuffer.splice(index, 1)
					}
					//如有需求 则调用接口删除已经发送的消息
				}
			})
			this.bufferResendSuccess = false
		},
		updSendError(groupid) {
			this.axios.get('SendMessage/SendError', {
				params: { groupId: groupid },
			})
		},
		/*消息重发的接口 Guid不变化 */
		bufferSendMessage(data) {
			var strs = { ...data }
			this.$delete(strs, 'sendTime')
			this.axios
				.post('SendMessage/SendMessage', strs, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then(function (data) {})
		},
		getMiniList() {
			let vm = this
			this.axios.get('SysMiniList').then(function ({ data }) {
				vm.miniList = data
			})
		},
		getQuick() {
			// let vm = this
			// this.axios.get('QuickReply/GetQuickByVM').then(function({ data }) {
			// 	if (data.result) {
			// 		vm.quickList = data.data
			// 	} else {
			// 		vm.$message({ type: 'error', message: data.message })
			// 	}
			// })
			// this.axios.get('quickReply/GetByVMs').then(function({ data }) {
			// 	if (data.result) {
			// 		vm.quickQuery = data.data
			// 	} else {
			// 		vm.$message({ type: 'error', message: data.message })
			// 	}
			// })
		},
		getExistingLian() {
			//获取当前连接成功的人数
			var header = {}
			let vm = this
			let strs = JSON.parse(localStorage.getItem('USER_INFO'))
			let token = strs ? strs.token : undefined
			if (token != null && token != undefined) {
				header.Authorization = token
			}
			this.axios
				.get('ExistingLian/GetExosting', {
					headers: header,
				})
				.then(({ data }) => {
					if (data != undefined) {
						vm.conversationData=[];
						data.forEach((item) => {
							let model = getJoinModel(item, '', '')
							console.debug(model)
							vm.conversationData.push(model)
						})
					}
					vm.asynConversationCount() //同步会话数量
				})
			// let $this = this
		},
		getOfflineList() {
			let vm = this
			this.axios.get('ExistingLian/GetOffLine').then(({ data }) => {
				if (data.result) {
					let arr = []
					data.data.forEach((item) => {
						let obj = {}
						obj.isCheck = false
						Object.assign(obj, item)
						arr.push(obj)
					})
					vm.offlineList = arr
				} else {
					vm.$notify.error({
						title: '错误',
						message: data.message,
					})
				}
			})
		},
		getAwait() {
			var vm = this
			var header = {}
			let strs = JSON.parse(localStorage.getItem('USER_INFO'))
			let token = strs ? strs.token : undefined
			if (token != null && token != undefined) {
				header.Authorization = token
			}
			this.axios
				.get('ExistingLian/GetAwaits', {
					headers: header,
				})
				.then(({ data }) => {
					if (data != undefined) {
						var arr = []
						data.forEach((item) => {
							let model = getJoinModel(item, '', '')
							arr.push(model)
						})
						vm.waitingData = arr
					}
				})
		},
		/***
		 * 初始化省市区
		 */
		getAddress() {
			let vm = this
			this.axios.get('Address/GetAdd').then(function ({ data }) {
				if (data.result) {
					vm.addressList = data.data
				}
			})
		},
		/***
		 * 发送消息
		 */
		sendMessage(data) {
			let vm = this
			let date = new DateTime()
			var guid = new GUID()
			let obj = vm.conversationData.find(
				(d) => d.conversationLogId == data.conversationLogId
			)
			if (obj == undefined) {
				vm.$alert('请先选中咨询人', '错误', {
					confirmButtonText: '确定',
				})
				return
			}
			data.sendTime = date.Now()
			data.groupMessageId = guid.newGUID() //给本条消息做上标记

			data.isSuccess = sendMessageState.Sending //是否发送成功
			if (obj.dialogues == null || obj.dialogues == undefined) {
				obj.dialogues = []
			}
			var timeArr = obj.dialogues
				.filter((d) => d.dialogues[0].sender == 1)
				.map((d) => d.sendTimeHM)
			let maxTime = Math.max(...timeArr)
			if (maxTime != -Infinity && maxTime != '') {
				let diffTime = date.millise - maxTime //响应时长
				data.dialogues.forEach((d) => {
					//计算响应时间
					d.ResponseSeconds = diffTime / 1000
				})
			}
			data.dialogues.forEach((d) => {
				d.accessChatId = vm.currentObj.accessChatId
			})
			data.resendCount = 0
			obj.dialogues.push({ ...data })
			var dataBuffer = JSON.parse(JSON.stringify(data))
			vm.sendMessageBuffer.push(dataBuffer)
			obj.kfLastSendTime = date.Now()
			obj.kfLastSendTimeHM = Date.now()
			vm.$delete(data, 'sendTime')
			vm.currentObj.dialogues = obj.dialogues
			vm.axios
				.post('SendMessage/SendMessage', data, {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then(function (data) {})
			//检查有没有使用快捷回复 如点击过则判断有没有发送成功
			if (vm.selectedReply.length > 0) {
				let quickIdArr = []
				let textArr = data.dialogues.filter((d) => d.messageType == 1)
				if (textArr.length > 0) {
					let text = ''
					textArr.forEach((d) => {
						text += d.content
					})
					vm.selectedReply.forEach((d) => {
						let index = text.indexOf(d.content)
						if (index > -1) {
							quickIdArr.push(d.id)
						}
					})
					if (quickIdArr.length > 0) {
						vm.axios
							.post('QuickReply/updUseCount', quickIdArr)
							.then(function ({ data }) {})
						vm.selectedReply = []
					}
				}
			}
		},
		/**
		 * 上传图片或视频并直接发送
		 */
		uploadFile(event) {
			//上传视频图片并发送
			let date = new DateTime()
			let $this = this
			this.axios
				.post('Upload', event, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function ({ data }) {
					if (data.result) {
						var obj = new Object()
						var Arr = []
						Arr.push(
							getSendMessage(
								$this.currentObj.userConversationId,
								$this.currentObj.consultId,
								data.type,
								data.href
							)
						)
						obj.Receiver = $this.currentObj.consultId
						obj.sendTime = date.Now()
						obj.conversationLogId =
							$this.currentObj.conversationLogId
						obj.dialogues = Arr
						$this.sendMessage(obj)
					} else {
				 
						$this.$message.error(data.err)
					}
				})
		},
		/***
		 * 选中的用户中转
		 */
		cusultInfo(data) {
			this.currentObj = data
			this.getUserInfo(data.consultId, data.accessChatId)
			this.getServiceRecord(data.consultId)
			this.consultNickName = data.cousultNickName
			this.errSendMsgMessage = this.sendMessageEnum[data.miniStateEnum]
			if (data.assemblyType == '1' && data.unreadCount > 0) {
				this.markedRead(data.userConversationId, data.consultId)
			}
		},
		/***
		 * 获取用户信息
		 */
		getUserInfo(openid, accessChatId) {
			if (
				openid == '' ||
				accessChatId == 0 ||
				accessChatId == undefined ||
				accessChatId == null ||
				openid == undefined ||
				openid == null
			) {
				return
			}
			let vm = this
			this.axios
				.get('ConsultantInfo/getUserInfo', {
					params: { openid: openid, accessChatId: accessChatId },
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.currentUserInfo = data.data
						// console.log(vm.currentUserInfo)
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
				})
		},
		tab(index) {
			this.eindex = index
		},
		upload() {
			this.$refs.file.click()
		},
		close() {
			this.reply = 'reply on'
			this.answer = 'answer on'
		},
		quickReply() {
			this.reply = 'reply'
			this.answer = 'answer'
		},
		switchto(data) {
			if (data == 0) {
				this.tabclass1 = 'on'
				this.tabclass2 = ''
			} else {
				this.tabclass1 = ''
				this.tabclass2 = 'on'
			}
		},
		handleChange(value) {},
		/*菜单切换*/
		cutover(index, item) {
			this.movement = item.component
		},
		manualAccessShows() {
			let $this = this
			this.axios
				.get('WaitingForUsers/GetWaiting')
				.then(function ({ data }) {
					if (data.status == 200) {
						$this.manualAccessData = data.data
					}
				})
			this.manualAccessShow = true
		},
		tranHandleClose() {
			this.manualAccessShow = false
		},
		tranOnAccess(accessid, channelId, awaitKey) {
			let $this = this
			if ($this.manualAccessClick) {
				return
			}
			$this.manualAccessClick = true
			this.axios
				.get('ExistingLian/ManualAccess', {
					params: {
						accessId: accessid,
						channelId: channelId,
						awaitKey: awaitKey,
					},
				})
				.then(function ({ data }) {
					if (data.result) {
						$this.$message({
							message: '接入成功',
							type: 'success',
						})
						$this.manualAccessShow = false
					} else {
						$this.$message({
							message: data.message,
							type: 'error',
						})
						$this.getAwait()
					}
					$this.manualAccessClick = false
				})
		},
		chatBoxTransfers(val) {
			let vm = this
			this.axios
				.get('ExistingLian/GetTransferUsers')
				.then(function ({ data }) {
					if (data.result) {
						vm.transferUsers = data.data
					}
				})
			vm.transferVisible = true
		},
		confirmTransferOrder(val) {
			let vm = this
			val.conversationLogId = vm.currentObj.conversationLogId
			val.accessChatId = vm.currentObj.accessChatId
			val.consultId = vm.currentObj.consultId
			this.axios
				.post('ExistingLian/tranOrder', val)
				.then(function ({ data }) {
					if (data.result) {
						let index = vm.conversationData.findIndex(
							(d) => d.cousultId == val.consultId
						)
						vm.$confirm('转接成功', '提示', {
							confirmButtonText: '确定',
							type: 'success',
							center: true,
						}).then(function () {
							if (index > -1) {
								vm.conversationData.splice(index, 1) //删除当前会话
							} else {
								//alert('转接错误：原因未找到')
								vm.$message.error("转接错误")
							}
							//这里切换下一个会话
							vm.transferVisible = false
							vm.restoreDefault() //恢复默认值
							vm.asynConversationCount() //更新父级的值
						})
					} else {
						vm.$confirm('转接失败', '提示', {
							confirmButtonText: '确定',
							type: 'error',
							center: true,
						})
					}
				})
		},
		closingSession(
			conversationlogs,
			userConversationIds,
			consultId,
			callback
		) {
			let vm = this
			if (consultId != vm.currentObj.consultId) {
				vm.$message({
					type: 'error',
					message: '失败,结束的Id与当前的不一致请重试',
				})
				return
			}
			let obj = new Object()
			obj.ConversationLogId = conversationlogs
			obj.AccessChatId = vm.currentObj.accessChatId
			obj.ConversationId = userConversationIds
			obj.ConsultId = consultId
			obj.EndType = 70001 //标识结束代码
			this.axios
				.post('ExistingLian/QuitConversation', obj)
				.then(function ({ data }) {
					if (data.result) {
						callback()
						let index = vm.conversationData.findIndex(
							(d) => d.cousultId == consultId
						)
						if (index > -1) {
							vm.conversationData.splice(index, 1) //删除当前会话
							vm.restoreDefault() //恢复默认值
							vm.sendMessageBuffer = vm.sendMessageBuffer.filter(
								(d) => d.Receiver != consultId
							)
						}
						vm.$message({
							type: 'success',
							message: '成功',
						})
						vm.asynConversationCount() //同步会话数量
					} else {
						vm.$message({
							type: 'error',
							message: '结束失败，请重试',
						})
					}
				})
		},
		getChatRecord(val, callback) {
			let vm = this
			val.isPc = true
			let obj = undefined
			if (val.assemblyType == '1') {
				obj = this.conversationData.find(
					(d) => d.conversationLogId == val.conversationLogId
				)
				if (obj.dialogues == null || obj.dialogues == undefined) {
					obj.dialogues = []
				}
			} else if (val.assemblyType == '3') {
				obj = this.offlineList.find(
					(d) => d.conversationLogId == val.conversationLogId
				)
				if (obj.dialogues == null || obj.dialogues == undefined) {
					obj.dialogues = []
				}
			} else {
				callback()
				return
			}
			this.axios
				.post('Dialogue/getDialogues', val)
				.then(function ({ data }) {
					if (data.result) {
						console.debug('测试:' + val.conversationLogId)
						if (data.data.list.length > 0) {
							obj.dialogues = data.data.list.concat(obj.dialogues)
							vm.currentObj.dialogues = obj.dialogues
							vm.currentObj.pagination = data.data.pagination
						}
						vm.chatBoxPageination = vm.currentObj.pagination
						callback()
					}
				})
		},
		miniMessageClose() {
			this.miniMessageVisible = false
		},
		miniMessageShow() {
			this.miniMessageVisible = true
		},
		saveCustomerCenter(val, callback) {
			let vm = this
			val.state = parseInt(val.state)
			if (val.accessChatId == undefined || val.accessChatId == 0) {
				val.accessChatId = vm.currentObj.accessChatId
			}
			this.axios
				.post('AccessChat_Subtotal', val)
				.then(function ({ data }) {
					if (!data.result) {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					} else {
						if (callback != undefined) {
							callback()
						}
						vm.$message({ type: 'success', message: '保存成功' })
						vm.getUserInfo(
							vm.currentObj.consultId,
							vm.currentObj.accessChatId
						)
						vm.getServiceRecord(vm.currentObj.consultId)
					}
				})
		},
		updUserInfo(val) {
			let vm = this
			this.axios
				.post('ConsultantInfo/updUserInfo', val)
				.then(function ({ data }) {
					if (!data.result) {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
				})
		},
		markedRead(userConversationId, consultId) {
			this.axios
				.get('SendMessage/markeRead', {
					params: {
						userConversationId: userConversationId,
						consultId: consultId,
					},
				})
				.then(function ({ data }) {})
		},
		getConsultationTypes() {
			let vm = this
			this.axios
				.get('ConsultationTypes/getConsultTypes')
				.then(function ({ data }) {
					if (data.result) {
						vm.consultationTypes = data.data
					}
				})
		},
		getServiceRecord(consultId) {
			let vm = this
			this.axios
				.get('AccessChat/GetSerRec', {
					params: { consultId: consultId },
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.serviceRecord = data.data
					} else {
						vm.$notify.error({ title: '错误', message: '获取失败' })
					}
				})
		},
		searchChatBox(val, callback) {
			let vm = this
			vm.dialogSearchs = true
			vm.searchKeyWord = val.content
			this.axios
				.post('Dialogue/GetDialogues', val)
				.then(function ({ data }) {
					if (callback == undefined) {
						vm.searchDialogues = data.data
					}
					if (callback != undefined) {
						//更改为回调给数据
						callback(data.data)
					}
				})
		},
		searchDialogue(val, callback) {
			let vm = this
			val.conversationLogId = vm.currentObj.conversationLogId
			val
			this.axios
				.post('dialogue/searchDialogues', val)
				.then(function ({ data }) {
					// vm.searchDialogues.list = data.data
					if (callback) {
						callback(data.data)
					}
				})
		},
		searchClose() {
			this.dialogSearchs = false
		},
		quickUseCountUpd(id) {
			this.axios.get('QuickReply/quickCountAdd', { params: { id: id } })
		},
		openQuickList(val) {
			this.userOrQuickList = 1
			this.quickObjects = val
		},
		sendQuick(val) {},
		operationSelectedReply(val) {
			this.selectedReply.push(val)
		},
		restoreDefault() {
			let vm = this
			vm.currentObj = {
				//还原默认值
				consultId: '',
				userConversationId: '',
				conversationLogId: 0,
				dialogues: [],
				entryTimeMillisecond: 0,
				cousultNickName: '',
				assemblyType: '1',
				entryTime: '',
				transferRemarks: '',
			}
			vm.serviceRecord = [] //把结束掉的会话 服务记录设置成空的
			vm.currentUserInfo = {} //当前信息设置成空
			if (vm.conversationData.length > 0) {
				vm.$refs.NextConversation.nextCusultInfo() //选中第一个
			}
			vm.$refs.chatBox.emptyInputBox()
		},
		saveAddressMonitorting(obj) {
			//自动识别保存地址
			this.$refs.userinfor.saveAddressMonitorting(obj)
		},
		quickTagType(val) {
			this.quickTagTypes = val
		},
		asynConversationCount() {
			this.$emit('conversationCount', this.conversationData.length)
		},
		asynJoinTime(id, cousultId, userConversationId) {
			this.axios.get('Log_Join/UpdPcTime', {
				params: {
					accessChatId: id,
					cousultId: cousultId,
					userConversationId: userConversationId,
				},
			})
		},
		getAccount() {
			let json = window.localStorage.getItem('USER_INFO')
			let obj = json != null ? JSON.parse(json) : null
			return obj.account
		},
	},
	components: {
		list,
		chatBox,
		quickReply,
		manualAccess,
		transitionModelBox,
		searchSession,
		miniMessage,
		userinfor,
		problemList,
	},
}
</script>

<style scoped>
.asideList {
	width: 100%;
	height: 100%;
}
/*用户信息*/
.message {
	padding: 0px 0 30px 30px;
	box-sizing: border-box;
}
.access {
	margin-top: 20px;
}
.option {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.lablelist span {
	display: inline-block;
	margin: 15px 15px 5px 0;
	color: #666;
	min-width: 60px;
}
.lablelist span.special {
	vertical-align: top;
}
.iconfont {
	cursor: pointer;
}
.access textarea {
	resize: none;
	width: 100%;
	height: 50px;
	padding: 5px;
	line-height: 20px;
	outline: none;
}
.remark {
	resize: none;
	margin-top: 10px;
}
.save {
	float: right;
	margin: 10px 20px;
}
.f-right {
	float: right;
	cursor: pointer;
}

/*菜单*/
.g-header {
	display: inline-block;
	float: right;
}
.g-header > div {
	display: inline-block;
}
.manage {
	margin-right: 50px;
	position: relative;
}
.work {
	position: relative;
	z-index: 50;
}

.dropdown-menu {
	width: 96px;
	position: absolute;
	padding: 6px 26px;
	background-color: #fff;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-o-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(0, 0, 0, 0.15);
	list-style: none;
	top: 62px;
	left: 50%;
	margin-left: -72px;
	border-radius: 3px;
}
.work .dropdown-menu {
	width: 50px;
	left: 50%;
	margin-left: -52px;
	text-align: center;
}
.dropdown-menu:before {
	position: absolute;
	right: 65px;
	top: -5px;
	content: '';
	z-index: 1;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 6px solid #fff;
}
.work .dropdown-menu:before {
	position: absolute;
	right: 41px;
	top: -5px;
	content: '';
	z-index: 1;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 6px solid #fff;
}
.dropdown-menu li {
	line-height: 40px;
}
.fadeInDown {
	-webkit-animation-name: fadeInDown;
	animation-name: fadeInDown;
}
.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}

@keyframes fadeInDown {
	0% {
		opacity: 0;
		-webkit-transform: translateY(-20px);
		-ms-transform: translateY(-20px);
		transform: translateY(-20px);
	}

	100% {
		opacity: 1;
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		transform: translateY(0);
	}
}
.icon-1 {
	display: inline-block;
	width: 14px;
	height: 14px;
	overflow: hidden;
	background-image: url(../../../assets/icons.png);
	background-size: 25px auto;
	background-position: 0 -270px;
	vertical-align: middle;
	margin-right: 4px;
}
.icon-2 {
	display: inline-block;
	width: 14px;
	height: 14px;
	background-image: url(../../../assets/icons.png);
	background-size: 25px auto;
	background-position: 0 -240px;
	vertical-align: middle;
	margin-right: 4px;
}
/*main*/
.main {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
	height: 100%;
	overflow-x: hidden;
}
.main1 {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	/* -ms-flex-direction: column;
	flex-direction: column; */
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.answer {
	width: 48%;
	height: 100%;
	border-right: 1px solid #ddd;
	transition: 0.2s width;
}
.answer.on {
	width: 64%;
}
.reply {
	width: 16%;
	height: 100%;
	border-right: 1px solid #ddd;
	overflow: hidden;
}
.reply.on {
	width: 0%;
}
.flex {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.points {
	height: 36px;
	line-height: 35px;
	padding-left: 30px;
	font-size: 12px;
	color: #fe1c11;
}
.connect {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	float: right;
	margin: 4px;
	font-size: 12px;
}
.Transfer {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	margin: 4px;
}
.aside {
	border-right: 1px solid #ddd;
	width: 18%;
	overflow-y: auto;
}
.reply .title {
	padding: 0 10px;
}

/*answer会话*/
.flex-title {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
.nickname {
	color: #bbb;
}
.flex-time span {
	color: #fe1c11;
}
.talk {
	padding: 10px 35px;
	height: 60%;
	border-bottom: 1px solid #ddd;
	overflow-y: auto;
	overflow-x: hidden;
}
.search-box {
	line-height: 44px;
	border-bottom: 1px solid #ddd;
}
.search-box .el-input-group {
	width: 320px;
	margin-left: 20px;
}
.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}
.container {
	overflow-x: hidden;
	overflow-y: auto;
}
/*滚动条样式*/
::-webkit-scrollbar {
	width: 7px;
}

::-webkit-scrollbar-track {
	border-radius: 4px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 4px;
}

.talk_left {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 10px;
	min-width: 100px;
}
.talk_left .content {
	margin-left: 10px;
}
.talk_left .content img {
	max-width: 300px;
}
.text {
	max-width: 400px;
	padding: 15px;
	background-color: #dcedf9;
	border-radius: 5px;
	font-size: 14px;
	letter-spacing: 1px;
}
.talk_left .text::after {
	position: absolute;
}
.talk_right {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-bottom: 10px;
}
.talk_right .content {
	margin-right: 10px;
}
.talk_right .content img {
	max-width: 225px;
}

.heading {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
.heading img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
.tool {
	height: 40px;
	line-height: 40px;
	padding: 0;
	background-color: #fafafa;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.tool i {
	font-size: 25px;
	margin-left: 20px;
	cursor: pointer;
	vertical-align: middle;
}
.charInput {
	padding: 5px 15px;
	min-height: 120px;
	max-height: 120px;
	outline: none;
	font-size: 20px;
	line-height: 30px;
	word-wrap: break-word;
}
/*表情*/

.send {
	display: inline-block;
	height: 35px;
	line-height: 35px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	float: right;
	margin: 4px;
	outline: none;
	border: none;
	cursor: pointer;
	margin-right: 20px;
}
.emoji_box {
	position: relative;
}
.emoji {
	position: absolute;
	background: #fff;
	width: 425px;
	height: 180px;
	border: 1px solid #ebeef5;
	padding: 12px;
	z-index: 2000;
	color: #606266;
	line-height: 1.4;
	text-align: justify;
	font-size: 14px;
	-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	word-break: break-all;
	bottom: 45px;
}
.emoji span {
	display: inline-block;
	width: 30px;
	height: 30px;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-style: normal;
	font-size: 20px;
}
.page {
	display: flex;
	bottom: 0;
	left: 0;
	width: 100%;
	padding-top: 5px;
	margin-top: 10px;
	border-top: 1px solid #e6e6e6;
}
.el-tabs__content {
	height: 130px;
}
.page > div {
	-webkit-box-flex: 1;
	flex: 1;
}
#file {
	display: none;
}
.setting {
	font-size: 26px;
	cursor: pointer;
}
.close {
	font-size: 24px;
	cursor: pointer;
	color: #888;
}
#noMessage {
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -100px;
	margin-top: -200px;
}
</style>
<style>
.chatframe-text img {
	display: inline-block;
	width: 20px;
	height: 20px;
	vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/talks/talk.vue